// generated from 4_199_604 samples

import { z } from "zod";
import { common } from "../common";

export const linkConfigSetSchema = z.record(
  z.string(),
  z.object({
    applied: z.boolean(),
    link_template_invocations: z.record(common.objectId, z.record(common.objectId, z.string())),
  })
);
